import { useState } from 'react';

export interface UseAnnotationFormStateReturn {
  isAnnotating: boolean;
  annotations: Record<string, string>;
  hasAnnotations: boolean;
  isAnnotated: (key: string) => boolean;

  onStartAnnotating: () => void;
  onExitAnnotating: () => void;
  onAnnotateImage: (key: string, dataUrl: string) => void;

  pendingRemovalKey: string | null;
  showRemoveAnnotationConfirm: boolean;
  onRequestRemoveAnnotation: (key: string) => void;
  onConfirmRemoveAnnotation: () => void;
  onCancelRemoveAnnotation: () => void;
}

export const useAnnotationFormState = (): UseAnnotationFormStateReturn => {
  const [isAnnotating, setIsAnnotating] = useState<boolean>(false);
  const [annotations, setAnnotations] = useState<Record<string, string>>({});
  const [pendingRemovalKey, setPendingRemovalKey] = useState<string | null>(
    null
  );

  const hasAnnotations: boolean = Object.keys(annotations).length > 0;

  const isAnnotated = (key: string): boolean => {
    return Boolean(annotations[key]);
  };

  const onStartAnnotating = (): void => {
    setIsAnnotating(true);
  };

  const onExitAnnotating = (): void => {
    setIsAnnotating(false);
  };

  const onAnnotateImage = (key: string, dataUrl: string): void => {
    setAnnotations((previous: Record<string, string>) => ({
      ...previous,
      [key]: dataUrl,
    }));
  };

  const onRequestRemoveAnnotation = (key: string): void => {
    setPendingRemovalKey(key);
  };

  const onCancelRemoveAnnotation = (): void => {
    setPendingRemovalKey(null);
  };

  const onConfirmRemoveAnnotation = (): void => {
    if (!pendingRemovalKey) {
      return;
    }

    setAnnotations((previous: Record<string, string>) => {
      const next: Record<string, string> = { ...previous };
      delete next[pendingRemovalKey];
      return next;
    });

    setPendingRemovalKey(null);
  };

  return {
    isAnnotating,
    annotations,
    hasAnnotations,
    isAnnotated,

    onStartAnnotating,
    onExitAnnotating,
    onAnnotateImage,

    pendingRemovalKey,
    showRemoveAnnotationConfirm: pendingRemovalKey !== null,
    onRequestRemoveAnnotation,
    onConfirmRemoveAnnotation,
    onCancelRemoveAnnotation,
  };
};